// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.desktop {
  background-color: #ffffff;
  height: 1600px;
  overflow-y: scroll;
  position: relative;
  width: 2400px;
}

.desktop .div {
  background-color: #ffffff;
  height: 100%;
  left: 0;
  overflow-y: scroll;
  position: absolute;
  top: 0;
  width: 100%;
}

.desktop .div::-webkit-scrollbar {
  display: none;
  width: 0;
}

.desktop .rectangle {
  background-color: #0e1116;
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}

.desktop .text-wrapper {
  color: #5da569;
  font-family: "Barlow Condensed-Bold", Helvetica;
  font-size: 96px;
  font-weight: 700;
  left: 681px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 708px;
  white-space: nowrap;
  width: 417px;
}

.desktop .text-wrapper-2 {
  color: #5da569;
  font-family: "Barlow Condensed-Bold", Helvetica;
  font-size: 96px;
  font-weight: 700;
  left: 686px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 467px;
  white-space: nowrap;
  width: 265px;
}

.desktop .overlap-group {
  height: 128px;
  left: 709px;
  position: absolute;
  top: 961px;
  width: 483px;
}

.desktop .img {
  height: 102px;
  left: 0;
  position: absolute;
  top: 0;
  width: 483px;
}

.desktop .CONFIRM {
  height: 128px;
  left: 108px;
  position: absolute;
  top: 0;
  width: 268px;
}

.desktop .rectangle-2 {
  height: 86px;
  left: 686px;
  position: absolute;
  top: 595px;
  width: 1028px;
}

.desktop .rectangle-3 {
  height: 86px;
  left: 686px;
  position: absolute;
  top: 836px;
  width: 1028px;
}

.desktop .sign-in-with-google {
  color: #9eaec3;
  font-family: "Barlow Condensed-Bold", Helvetica;
  font-size: 52px;
  font-weight: 700;
  left: 1081px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  text-decoration: underline;
  top: 1089px;
  width: 444px;
}

.desktop .image {
  aspect-ratio: 0.98;
  height: 62px;
  left: 1006px;
  object-fit: cover;
  position: absolute;
  top: 1089px;
  width: 61px;
}

.desktop .text-wrapper-3 {
  -webkit-text-stroke: 1px #000000;
  color: #5da569;
  font-family: "Barlow Condensed-Bold", Helvetica;
  font-size: 137px;
  font-weight: 700;
  left: calc(50.00% - 183px);
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 302px;
  white-space: nowrap;
  width: 696px;
}

.desktop .text-wrapper-4 {
  color: #9eaec3;
  font-family: "Barlow Condensed-Bold", Helvetica;
  font-size: 49px;
  font-weight: 700;
  left: 1232px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  text-decoration: underline;
  top: 981px;
  width: 482px;
}

.desktop::-webkit-scrollbar {
  display: none;
  width: 0;
}`, "",{"version":3,"sources":["webpack://./src/Pages/Login/style.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,OAAO;EACP,kBAAkB;EAClB,kBAAkB;EAClB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,OAAO;EACP,kBAAkB;EAClB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,cAAc;EACd,+CAA+C;EAC/C,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,+CAA+C;EAC/C,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,aAAa;EACb,OAAO;EACP,kBAAkB;EAClB,MAAM;EACN,YAAY;AACd;;AAEA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,aAAa;AACf;;AAEA;EACE,cAAc;EACd,+CAA+C;EAC/C,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;EAC1B,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,gCAAgC;EAChC,cAAc;EACd,+CAA+C;EAC/C,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,+CAA+C;EAC/C,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;EAC1B,UAAU;EACV,YAAY;AACd;;AAEA;EACE,aAAa;EACb,QAAQ;AACV","sourcesContent":[".desktop {\n  background-color: #ffffff;\n  height: 1600px;\n  overflow-y: scroll;\n  position: relative;\n  width: 2400px;\n}\n\n.desktop .div {\n  background-color: #ffffff;\n  height: 100%;\n  left: 0;\n  overflow-y: scroll;\n  position: absolute;\n  top: 0;\n  width: 100%;\n}\n\n.desktop .div::-webkit-scrollbar {\n  display: none;\n  width: 0;\n}\n\n.desktop .rectangle {\n  background-color: #0e1116;\n  height: 100%;\n  left: 0;\n  position: absolute;\n  top: 0;\n  width: 100%;\n}\n\n.desktop .text-wrapper {\n  color: #5da569;\n  font-family: \"Barlow Condensed-Bold\", Helvetica;\n  font-size: 96px;\n  font-weight: 700;\n  left: 681px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: absolute;\n  top: 708px;\n  white-space: nowrap;\n  width: 417px;\n}\n\n.desktop .text-wrapper-2 {\n  color: #5da569;\n  font-family: \"Barlow Condensed-Bold\", Helvetica;\n  font-size: 96px;\n  font-weight: 700;\n  left: 686px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: absolute;\n  top: 467px;\n  white-space: nowrap;\n  width: 265px;\n}\n\n.desktop .overlap-group {\n  height: 128px;\n  left: 709px;\n  position: absolute;\n  top: 961px;\n  width: 483px;\n}\n\n.desktop .img {\n  height: 102px;\n  left: 0;\n  position: absolute;\n  top: 0;\n  width: 483px;\n}\n\n.desktop .CONFIRM {\n  height: 128px;\n  left: 108px;\n  position: absolute;\n  top: 0;\n  width: 268px;\n}\n\n.desktop .rectangle-2 {\n  height: 86px;\n  left: 686px;\n  position: absolute;\n  top: 595px;\n  width: 1028px;\n}\n\n.desktop .rectangle-3 {\n  height: 86px;\n  left: 686px;\n  position: absolute;\n  top: 836px;\n  width: 1028px;\n}\n\n.desktop .sign-in-with-google {\n  color: #9eaec3;\n  font-family: \"Barlow Condensed-Bold\", Helvetica;\n  font-size: 52px;\n  font-weight: 700;\n  left: 1081px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: absolute;\n  text-decoration: underline;\n  top: 1089px;\n  width: 444px;\n}\n\n.desktop .image {\n  aspect-ratio: 0.98;\n  height: 62px;\n  left: 1006px;\n  object-fit: cover;\n  position: absolute;\n  top: 1089px;\n  width: 61px;\n}\n\n.desktop .text-wrapper-3 {\n  -webkit-text-stroke: 1px #000000;\n  color: #5da569;\n  font-family: \"Barlow Condensed-Bold\", Helvetica;\n  font-size: 137px;\n  font-weight: 700;\n  left: calc(50.00% - 183px);\n  letter-spacing: 0;\n  line-height: normal;\n  position: absolute;\n  top: 302px;\n  white-space: nowrap;\n  width: 696px;\n}\n\n.desktop .text-wrapper-4 {\n  color: #9eaec3;\n  font-family: \"Barlow Condensed-Bold\", Helvetica;\n  font-size: 49px;\n  font-weight: 700;\n  left: 1232px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: absolute;\n  text-decoration: underline;\n  top: 981px;\n  width: 482px;\n}\n\n.desktop::-webkit-scrollbar {\n  display: none;\n  width: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
